import createValidationFn from '@gef-ui/form-core/validations/createValidationFn';
import { onlyAllowedCharsDisjoint } from '@gef-ui/form-core/validations/validationFunctions/text';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { regexClaimNumber } from '../constants';
import { isLength } from './common';

const minLength = isLength({
	minLength: 4,
	maxLength: 20,
	minLengthMessageKey: 'validation:lengthBetweenScope',
});

const allowedChars = onlyAllowedCharsDisjoint({
	regex: new RegExp(regexClaimNumber),
	messageKey: 'validation:allowedCharactersClaimNo',
});

const isNotZeros = (fieldValue) => {
	if (isNaN(fieldValue)) {
		return null;
	} else {
		return fieldValue > 0 ? false : getLabelMessage('validations:notAllowedAllNulls');
	}
};

export default createValidationFn(() => (args) => {
	const { fieldValue } = args;
	if (!fieldValue) {
		return null;
	}

	return (
		allowedChars.validate(args)?.errorMessage || minLength.validate(args)?.errorMessage || isNotZeros(fieldValue)
	);
});
